import { useNavigate } from "react-router-dom";
import styles from "../../styles/Vision/Vision.module.css";

const Visions = [
  {
    title: "Idea To Impact",
    desc: "From Your First Concept To Scalable Solutions, We Guide Every Step.",
  },
  {
    title: "Tailored Playbooks",
    desc: "Proven frameworks to simplify execution and accelerate results.",
  },
  {
    title: "Focused Expertise",
    desc: "Agile, lean, and tech-driven strategies for every growth stage.",
  },
  {
    title: "Your Growth Partners",
    desc: "A hands-on team that’s invested in your success.",
  },
];

const Vision = () => {
  const navigate = useNavigate();
  const handleGetStarted = () => {
    navigate("/contact-us", { state: { scrollToForm: true } }); // Pass state
  };
  return (
    <div id={styles.VisionContainer}>
      <div id={styles.VisionInnerContainer}>
        <div id={styles.VisionTitle}>
          Your Vision, Our Code, Together We Build Success
        </div>

        <div>
          <p id={styles.VisionDesc}>
            At LovenCoders, we don’t just consult, we co-create with tailored
            strategies, expert tools & actionable insights, we empower your
            startup to navigate challenges, seize opportunities & achieve
            unparalleled growth.
          </p>
        </div>

        <div className={styles.VisionComponentContainer}>
          {Visions.map((vision, index) => (
            <div key={index} className={styles.VisionComponent}>
              <div className={styles.VisionComponentTitle}>{vision.title}</div>
              <div className={styles.VisionComponentDesc}>{vision.desc}</div>
            </div>
          ))}
        </div>

        <div>
          <button className={styles.VisionBtn} onClick={handleGetStarted}>Partner With Us Today</button>
        </div>

        <div id={styles.VisionInfo}>
          Let’s turn your vision into reality. Click now to begin your journey
          with LovenCoders!
        </div>
      </div>
    </div>
  );
};

export default Vision;
